import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var channelAdmin = [{
  path: '/channel-info-list',
  component: function component() {
    return import('@/views/channelAdmin/channelInfoList/index.vue');
  },
  meta: {
    title: '渠道信息列表',
    keepAlive: false
  },
  children: []
}, {
  path: '/channel-bind-list',
  component: function component() {
    return import('@/views/channelAdmin/channelBindList/index.vue');
  },
  meta: {
    title: '绑定渠道列表',
    // 获取所有渠道
    keepAlive: false
  },
  children: []
},
//
{
  path: '/channel-base-info',
  component: function component() {
    return import('@/views/channelAdmin/channelBaseInfo/index.vue');
  },
  meta: {
    title: '渠道基础信息',
    // 获取所有渠道
    keepAlive: false
  },
  children: []
}, {
  path: '/channel-product-offer',
  component: function component() {
    return import('@/views/channelAdmin/productOffer/index.vue');
  },
  meta: {
    title: '报价单',
    // 获取所有渠道
    keepAlive: false
  },
  children: []
}, {
  path: '/channel-contract',
  component: function component() {
    return import('@/views/channelAdmin/channelContract/index.vue');
  },
  meta: {
    title: '渠道合同',
    // 获取所有渠道
    keepAlive: false
  },
  children: []
}, {
  path: '/channel-product-record',
  component: function component() {
    return import('@/views/channelAdmin/productRecord/index.vue');
  },
  meta: {
    title: '生产记录',
    // 获取所有渠道
    keepAlive: false
  },
  children: []
}, {
  path: '/channel-request-record',
  component: function component() {
    return import('@/views/channelAdmin/channelRequestRecord/index.vue');
  },
  meta: {
    title: '请款记录',
    // 获取所有渠道
    keepAlive: false
  },
  children: []
}, {
  path: '/channel-operation-record',
  component: function component() {
    return import('@/views/channelAdmin/operationRecord/index.vue');
  },
  meta: {
    title: '操作记录',
    // 获取所有渠道
    keepAlive: false
  },
  children: []
}];